import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { internalUseOnlyPriority5 } from "./H5";
const Title5Styled = styled.div.withConfig({
  componentId: "sc-1qieds4-0"
})(["", ";"], internalUseOnlyPriority5);
/**
 * Titles are styled to be parents of text. A title style may or may not correspond directly with an HTML heading (H1, H2, etc).
 */

const Title5 = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(Title5Styled, props, children);

export default Title5;
Title5.propTypes = {
  /** Content inside title */
  children: PropTypes.node.isRequired
};